export enum PregnancyStatus {
  Pregnant = "pregnant",
  NotPregnant = "not-pregnant",
  NotSure = "not-sure",
}
